import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function SpecialityIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <g id="Group 1000007230">
      <path id="Vector 4226" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
            d="M4.96875 13.5006c2.85079 -0.2742 5.68045 -0.2742 8.53125 0" strokeWidth="1"></path>
    </g>
    <path id="Intersect" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M13.1758 2.92611c-1.8199 1.89996 -3.57615 3.64105 -5.5334 5.48791L5.58984 6.36146C7.4367 4.40421 9.17779 2.64795 11.0777 0.82807c0.5103 -0.488768 1.376 -0.419847 1.947 0.151116 0.5709 0.570964 0.6399 1.436654 0.1511 1.946924Z"
          strokeWidth="1"></path>
    <path id="Intersect_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M5.58819 6.35938C3.94888 7.87056 2.01168 9.80776 0.500488 11.4471c1.115152 0.1799 2.313172 0.2431 3.486562 0.1896 1.18873 -0.0542 2.21752 -0.7827 2.8219 -1.80777l0.04725 -0.08014c0.46322 -0.78563 0.33628 -1.78512 -0.30861 -2.43002l-0.9594 -0.95939Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
